import { END_POINTS } from '@/api/end-points'
import fetch from '../fetch-with-authorization'

/**
 * Fetches all Plaid loan transactions for a given Plaid item by paginating through all pages
 * @param {string} plaidItemId - The Plaid item ID
 * @param {number} pageSize - Number of transactions per page (default: 500)
 * @returns {Promise<Array>} Array of all transactions
 */
export const getPlaidLoanTransactions = async ({ plaidItemId, pageSize = 500 }) => {
  const allTransactions = []
  let pageNumber = 1
  let hasNextPage = true

  while (hasNextPage) {
    const response = await fetch({
      path: `${END_POINTS.TRANSACTIONS.LOANS.GET_PLAID_LOAN_TRANSACTIONS}?plaid-item-id=${plaidItemId}&page-number=${pageNumber}&page-size=${pageSize}`,
    })

    if (response.transactions && Array.isArray(response.transactions)) {
      allTransactions.push(...response.transactions)
    }

    hasNextPage = response.pageInfo?.hasNextPage || false
    pageNumber++
  }

  return allTransactions
}

/**
 * Submit manually selected loan/lease transactions for review
 * @param {string} plaidItemId - The Plaid item ID
 * @param {Array<string>} transactionIds - Array of Plaid transaction IDs to submit
 * @returns {Promise<Object>} Response with success status and transactionsAdded count
 */
export const submitLoanTransactionsForReview = async ({ plaidItemId, transactionIds }) => {
  const data = await fetch({
    path: END_POINTS.TRANSACTIONS.LOANS.SUBMIT_LOAN_TRANSACTIONS_FOR_REVIEW,
    method: 'POST',
    body: JSON.stringify({ plaidItemId, transactionIds }),
  })
  return data
}

